import { gql } from '@apollo/client';
import { PARAMETER_FIELDS } from "./parameter";

// TODO remove ConfigurableField Fields
/**
 * @deprecated
 */
export const CONFIGURABLE_FIELD_FIELDS = gql`
  fragment ConfigurableFieldFields on ConfigurableFieldDto {
    parameterId
    groupId
    relatedObjectName
    labelParameter
    linea
    parameterChildId
    parameterChildCode
    comboCodeLabel
    repeatable
    labelParameterChild
    validationRegex
    relatedObjectType
    id
    state
    obligatory
    editable
    dataType
    dataValue
    objectParameterId
    parameterCode
    ignoreValidation
    groupName
    verificable
    auditable
    remarks
  }
`;
export const CONSENT_RELATED_TEXT_FIELDS = gql`
  fragment ConsentRelatedTextFields on TextRelatedDto {
    role
    situation
    textDto {
      businessUnitCodename
      relatedObjectTypeID
      name
      creationTimestamp
      textTemplate {
        template
        code
        objectTypeId
        name
      }
      id
      text
      businessUnitId
      status
      relatedID
    }
  }
`;
export const CONSENT_RELATED_ARCHIVE_FIELDS = gql`
  fragment ConsentRelatedArchiveFields on ArchiveRelatedDto {
    role
    situation
    idRelated
    archiveDto {
      businessUnitName
      createdBy
      name
      creationTimestamp
      modifiedBy
      id
      businessUnitId
      timestamp
      status
    }
  }
`;
export const CONSENTS_FIELDS = gql`
  ${PARAMETER_FIELDS}
  ${CONSENT_RELATED_TEXT_FIELDS}
  ${CONSENT_RELATED_ARCHIVE_FIELDS}
  fragment ConsentsFields on ConsentsDTO {
    related_text {
      ...ConsentRelatedTextFields
    }
    parameters {
      ...ParameterFields
    }
    related_archive {
      ...ConsentRelatedArchiveFields
    }
    clientIp
    name
    id
    status
  }
`;
export const CONSENTS_GROUP_FIELDS = gql`
  ${CONSENTS_FIELDS}
  fragment ConsentsGroupFields on ConsentsGroupDTO {
    name
    consents {
      ...ConsentsFields
    }
    id
    statusTree {
      treelevel1
      treelevel2
      treelevel3
      treelevel4
    }
  }
`;